import Big from 'big.js'
import { useContext } from 'react'

import { MetronomeContext } from '../components/MetronomeContext'

export const useDisabledOperation = function ({ asset, operation }) {
  const {
    disableOnOperation,
    selectedPoolData: {
      status: { everythingStopped, isSwapActive, paused }
    }
  } = useContext(MetronomeContext)

  return {
    assetIsInactive:
      !asset?.isActive &&
      (operation === 'deposit' ||
        operation === 'generate' ||
        operation === 'leverage' ||
        operation === 'swap'),
    disableOnOperation,
    isPaused: paused && operation === 'deposit',
    isStopped:
      everythingStopped &&
      (operation === 'generate' ||
        operation === 'leverage' ||
        operation === 'repay' ||
        operation === 'withdraw' ||
        operation === 'swap'),
    noSupply: Big(asset?.availableSupply ?? 0).lte(0),
    swapIsInactive: !isSwapActive && operation === 'swap'
  }
}
